import { Injectable, Injector } from '@angular/core';
import { IHierarchyElementDto } from '@common-modules/dependencies/he/hierarchy-element.dto';
import { InjectableByKey } from '@common-modules/shared/injectable-by-key/injectable-by-key.decorator';
import { PagedResultDto } from '@common-modules/shared/model/paged-result.dto';
import { GridODataService } from '@common-modules/shared/odata/grid-odata.service';

const API_BASE = '/api/he/selection';

@InjectableByKey({ key: 'HierarchySelectionService' })
@Injectable({ providedIn: 'root' })
export class HierarchySelectionService extends GridODataService<IHierarchyElementDto> {
  constructor(injector: Injector) {
    super(injector, API_BASE);
  }

  protected mapResponse(
    response: PagedResultDto<IHierarchyElementDto>
  ): PagedResultDto<IHierarchyElementDto> {
    return response;
  }
}
